(function () {
  // Prevent double install
  if (window._upsellAddInterceptInstalled) return;
  window._upsellAddInterceptInstalled = true;

  // Run when DOM is ready
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    // Get all upsell checkboxes
    function getUpsellCheckboxes() {
      return Array.from(document.querySelectorAll('.add-upsell-checkbox'));
    }

    // Exit early if no upsell checkboxes exist
    if (getUpsellCheckboxes().length === 0) return;

    // Locate product form and "Add to Cart" button
    function resolveFormAndButton() {
      const anyCheckbox = getUpsellCheckboxes()[0];
      const container = anyCheckbox.closest('.productdescription-container') || document;
      const form = container.querySelector('form.w-commerce-commerceaddtocartform') || document.querySelector('form.w-commerce-commerceaddtocartform');
      let addButton = null;
      if (form) {
        addButton = form.querySelector('input[type="submit"], button[type="submit"], .w-commerce-commerceaddtocartbutton') ||
                    form.querySelector('button, input[type="submit"]');
      }
      return { form, addButton };
    }

    let { form, addButton } = resolveFormAndButton();
    if (!form) return;

    // AJAX add-to-cart helper
    async function addVariantAjax(variantId, quantity = 1) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) })
      });
      if (!res.ok) throw await res.json();
      return res.json();
    }

    // Show toast notification
    function showToast(message) {
      const id = 'upsell-addon-toast';
      const existing = document.getElementById(id);
      if (existing) existing.remove();

      const toast = document.createElement('div');
      toast.id = id;
      toast.style.position = 'fixed';
      toast.style.right = '20px';
      toast.style.bottom = '20px';
      toast.style.background = 'rgba(0,0,0,0.85)';
      toast.style.color = '#fff';
      toast.style.padding = '10px 14px';
      toast.style.borderRadius = '6px';
      toast.style.zIndex = 99999;
      toast.style.fontSize = '14px';
      toast.style.pointerEvents = 'none';
      toast.textContent = message || 'Added to cart';
      document.body.appendChild(toast);

      toast.style.opacity = '1';
      setTimeout(() => {
        toast.style.transition = 'opacity 250ms';
        toast.style.opacity = '0';
        setTimeout(() => toast.remove(), 300);
      }, 1600);
    }

    // Update cart UI elements
    function refreshCartUI() {
      if (typeof window.updateCart === 'function') {
        try { window.updateCart(); } catch (e) { console.warn(e); }
      }

      if (typeof window.renderCart === 'function') {
        try { window.renderCart(); } catch (e) { console.warn(e); }
      }

      return fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          ['.cart-count', '.cart-qty', '[data-cart-count]', '[data-cart-quantity]'].forEach(selector => {
            document.querySelectorAll(selector).forEach(el => {
              el.textContent = cart.item_count;
            });
          });
          return cart;
        })
        .catch(err => console.warn('refreshCartUI error', err));
    }

    // Prevents triggering multiple add flows
    const programmaticFlagKey = '_upsellProgrammaticClick';
    window[programmaticFlagKey] = window[programmaticFlagKey] || false;

    // Get variant IDs from selected checkboxes
    function getCheckedVariantIds() {
      return getUpsellCheckboxes()
        .filter(cb => cb && cb.checked && cb.dataset && cb.dataset.extraVariantId)
        .map(cb => cb.dataset.extraVariantId)
        .filter(Boolean);
    }

    // Add each variant sequentially
    function addMultipleExtrasSequentially(variantIds) {
      return variantIds.reduce((promise, vid) => {
        return promise.then(() => addVariantAjax(vid, 1));
      }, Promise.resolve());
    }

    // Main handler to add extras, then main product
    function handleAddonThenTrigger(button) {
      const variantIds = getCheckedVariantIds();

      if (!variantIds.length) {
        // No upsells selected
        window[programmaticFlagKey] = true;
        setTimeout(() => {
          button.click();
          setTimeout(() => { window[programmaticFlagKey] = false; }, 800);
        }, 0);
        return;
      }

      // Add upsells, then main item
      addMultipleExtrasSequentially(variantIds).then(() => {
        window[programmaticFlagKey] = true;
        setTimeout(() => {
          button.click();
          setTimeout(() => {
            window[programmaticFlagKey] = false;
            refreshCartUI();
            showToast('Added to cart');
          }, 800);
        }, 0);
      }).catch(err => {
        console.error('Failed adding upsells:', err);
        // Fallback: still trigger main add
        window[programmaticFlagKey] = true;
        setTimeout(() => {
          button.click();
          setTimeout(() => { window[programmaticFlagKey] = false; }, 800);
        }, 0);
      });
    }

    // Bind handler to add button
    function attachAddButtonHandler(button) {
      if (!button) return;

      button.addEventListener('click', (e) => {
        if (window[programmaticFlagKey]) return;
        if (!getCheckedVariantIds().length) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        handleAddonThenTrigger(button);
      }, true);
    }

    attachAddButtonHandler(addButton);

    // Intercept form submit (e.g. enter key)
    form.addEventListener('submit', (e) => {
      if (window[programmaticFlagKey]) return;
      if (!getCheckedVariantIds().length) return;
      e.preventDefault();

      if (addButton) {
        handleAddonThenTrigger(addButton);
      } else {
        // Fallback: add extras, then submit
        const variantIds = getCheckedVariantIds();
        if (variantIds.length) {
          addMultipleExtrasSequentially(variantIds).then(() => {
            try {
              window[programmaticFlagKey] = true;
              const btn = form.querySelector('input[type="submit"], button[type="submit"]');
              if (btn) btn.click();
              else form.submit();
              setTimeout(() => {
                window[programmaticFlagKey] = false;
                refreshCartUI();
                showToast('Added to cart');
              }, 800);
            } catch (err) {
              window[programmaticFlagKey] = false;
              form.submit();
            }
          }).catch(() => form.submit());
        } else {
          form.submit();
        }
      }
    });

    // Rebind logic if theme dynamically changes DOM
    const observer = new MutationObserver(() => {
      const refs = resolveFormAndButton();
      if (!refs.form) return;
      form = refs.form;
      if (refs.addButton && refs.addButton !== addButton) {
        addButton = refs.addButton;
        attachAddButtonHandler(addButton);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

  });
})();

// --- Visual selection handling & animation ---

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.upsell-box-wrapper').forEach(function (box) {
    const checkbox = box.querySelector('.add-upsell-checkbox');
    const clickTarget = box.querySelector('.upsell-box-text-wrapper');

    if (!checkbox || !clickTarget) return;

    // Initial load state
    if (checkbox.checked) {
      box.classList.add('selected');
    }

    // Toggle on click
    clickTarget.addEventListener('click', function () {
      checkbox.checked = !checkbox.checked;

      if (checkbox.checked) {
        box.classList.add('selected');
      } else {
        box.classList.remove('selected');
      }
    });
  });
});
